@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(852_351_005)
internal val Res.string.ui_devices_edit_deviceeui_mode_picker: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_mode_picker", "ui_devices_edit_deviceeui_mode_picker", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14221, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13597, 53),
      ))
    }

@delegate:ResourceContentHash(789_435_372)
internal val Res.string.ui_devices_edit_deviceeui_no_image: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_no_image", "ui_devices_edit_deviceeui_no_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14283, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13651, 54),
      ))
    }

@delegate:ResourceContentHash(1_039_136_930)
internal val Res.string.ui_devices_edit_deviceeui_no_locations_found: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_no_locations_found", "ui_devices_edit_deviceeui_no_locations_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14342, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13706, 76),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.ui_devices_edit_deviceeui_ok: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_ok", "ui_devices_edit_deviceeui_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14427, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13783, 40),
      ))
    }

@delegate:ResourceContentHash(-1_880_793_913)
internal val Res.string.ui_devices_edit_deviceeui_orientation_horizontal: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_horizontal", "ui_devices_edit_deviceeui_orientation_horizontal", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14578, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13926, 80),
      ))
    }

@delegate:ResourceContentHash(1_704_725_411)
internal val Res.string.ui_devices_edit_deviceeui_orientation_horizontal_reversed: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_horizontal_reversed", "ui_devices_edit_deviceeui_orientation_horizontal_reversed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14472, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13824, 101),
      ))
    }

@delegate:ResourceContentHash(395_207_407)
internal val Res.string.ui_devices_edit_deviceeui_orientation_vertical: StringResource by lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_vertical", "ui_devices_edit_deviceeui_orientation_vertical", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14759, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14107, 74),
      ))
    }

@delegate:ResourceContentHash(-1_609_945_429)
internal val Res.string.ui_devices_edit_deviceeui_orientation_vertical_reversed: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_orientation_vertical_reversed", "ui_devices_edit_deviceeui_orientation_vertical_reversed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14659, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14007, 99),
      ))
    }

@delegate:ResourceContentHash(2_101_478_870)
internal val Res.string.ui_devices_edit_deviceeui_search_location_placeholder: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_search_location_placeholder", "ui_devices_edit_deviceeui_search_location_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14838, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14182, 77),
      ))
    }

@delegate:ResourceContentHash(1_278_651_301)
internal val Res.string.ui_devices_edit_deviceeui_select_location_placeholder: StringResource by
    lazy {
      StringResource("string:ui_devices_edit_deviceeui_select_location_placeholder", "ui_devices_edit_deviceeui_select_location_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 14928, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14260, 85),
      ))
    }

@delegate:ResourceContentHash(959_713_004)
internal val Res.string.ui_devices_listing_btn_load_more: StringResource by lazy {
      StringResource("string:ui_devices_listing_btn_load_more", "ui_devices_listing_btn_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15018, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14346, 52),
      ))
    }

@delegate:ResourceContentHash(-1_238_925_862)
internal val Res.string.ui_devices_listing_header_campaigns: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_campaigns", "ui_devices_listing_header_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15079, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14399, 55),
      ))
    }

@delegate:ResourceContentHash(81_821_120)
internal val Res.string.ui_devices_listing_header_id: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_id", "ui_devices_listing_header_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15135, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14455, 40),
      ))
    }

@delegate:ResourceContentHash(1_897_430_367)
internal val Res.string.ui_devices_listing_header_name: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_name", "ui_devices_listing_header_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15176, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14496, 54),
      ))
    }

@delegate:ResourceContentHash(-1_315_232_960)
internal val Res.string.ui_devices_listing_header_status: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_status", "ui_devices_listing_header_status", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15235, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14551, 48),
      ))
    }

@delegate:ResourceContentHash(-1_707_257_235)
internal val Res.string.ui_devices_listing_header_type: StringResource by lazy {
      StringResource("string:ui_devices_listing_header_type", "ui_devices_listing_header_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15284, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14600, 46),
      ))
    }

@delegate:ResourceContentHash(-1_267_153_063)
internal val Res.string.ui_devices_listing_placeholder_search: StringResource by lazy {
      StringResource("string:ui_devices_listing_placeholder_search", "ui_devices_listing_placeholder_search", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15331, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14647, 61),
      ))
    }

@delegate:ResourceContentHash(1_709_888_971)
internal val Res.string.ui_devices_listing_showing: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing", "ui_devices_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15563, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14863, 78),
      ))
    }

@delegate:ResourceContentHash(95_044_728)
internal val Res.string.ui_devices_listing_showing_middle: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing_middle", "ui_devices_listing_showing_middle", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15405, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14709, 45),
      ))
    }

@delegate:ResourceContentHash(462_025_241)
internal val Res.string.ui_devices_listing_showing_prefix: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing_prefix", "ui_devices_listing_showing_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15451, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14755, 53),
      ))
    }

@delegate:ResourceContentHash(-2_043_824_381)
internal val Res.string.ui_devices_listing_showing_suffix: StringResource by lazy {
      StringResource("string:ui_devices_listing_showing_suffix", "ui_devices_listing_showing_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15509, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14809, 53),
      ))
    }

@delegate:ResourceContentHash(1_769_579_710)
internal val Res.string.ui_devices_listing_stat_offline: StringResource by lazy {
      StringResource("string:ui_devices_listing_stat_offline", "ui_devices_listing_stat_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15650, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14942, 51),
      ))
    }

@delegate:ResourceContentHash(-1_707_876_243)
internal val Res.string.ui_devices_listing_stat_online: StringResource by lazy {
      StringResource("string:ui_devices_listing_stat_online", "ui_devices_listing_stat_online", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15706, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14994, 46),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_devices_listing_stat_total: StringResource by lazy {
      StringResource("string:ui_devices_listing_stat_total", "ui_devices_listing_stat_total", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15757, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15041, 49),
      ))
    }

@delegate:ResourceContentHash(-1_085_949_842)
internal val Res.string.ui_devices_listing_title: StringResource by lazy {
      StringResource("string:ui_devices_listing_title", "ui_devices_listing_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15807, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15091, 60),
      ))
    }

@delegate:ResourceContentHash(116_606_363)
internal val Res.string.ui_devices_listing_type_indoor: StringResource by lazy {
      StringResource("string:ui_devices_listing_type_indoor", "ui_devices_listing_type_indoor", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15872, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15152, 46),
      ))
    }

@delegate:ResourceContentHash(967_519_333)
internal val Res.string.ui_devices_listing_type_outdoor: StringResource by lazy {
      StringResource("string:ui_devices_listing_type_outdoor", "ui_devices_listing_type_outdoor", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15923, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15199, 51),
      ))
    }

@delegate:ResourceContentHash(30_127_065)
internal val Res.string.ui_devices_splash_desc: StringResource by lazy {
      StringResource("string:ui_devices_splash_desc", "ui_devices_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 15975, 286),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15251, 290),
      ))
    }

@delegate:ResourceContentHash(-1_097_985_949)
internal val Res.string.ui_devices_splash_title: StringResource by lazy {
      StringResource("string:ui_devices_splash_title", "ui_devices_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16262, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15542, 51),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_locations_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_locations_detail_btn_delete", "ui_locations_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16318, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15594, 46),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_locations_detail_btn_edit: StringResource by lazy {
      StringResource("string:ui_locations_detail_btn_edit", "ui_locations_detail_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16369, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15641, 44),
      ))
    }

@delegate:ResourceContentHash(1_383_998_125)
internal val Res.string.ui_locations_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_locations_detail_delete_confirm_message", "ui_locations_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16414, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15686, 114),
      ))
    }

@delegate:ResourceContentHash(1_127_114_407)
internal val Res.string.ui_locations_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_locations_detail_delete_confirm_title", "ui_locations_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16533, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15801, 68),
      ))
    }

@delegate:ResourceContentHash(376_591_794)
internal val Res.string.ui_locations_detail_delete_failed: StringResource by lazy {
      StringResource("string:ui_locations_detail_delete_failed", "ui_locations_detail_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16606, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15870, 77),
      ))
    }

@delegate:ResourceContentHash(1_305_446_188)
internal val Res.string.ui_locations_detail_devices_count: StringResource by lazy {
      StringResource("string:ui_locations_detail_devices_count", "ui_locations_detail_devices_count", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16688, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15948, 57),
      ))
    }

@delegate:ResourceContentHash(2_071_617_355)
internal val Res.string.ui_locations_detail_search_hint: StringResource by lazy {
      StringResource("string:ui_locations_detail_search_hint", "ui_locations_detail_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16750, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16006, 67),
      ))
    }

@delegate:ResourceContentHash(1_908_192_713)
internal val Res.string.ui_locations_details_indoor_nodes: StringResource by lazy {
      StringResource("string:ui_locations_details_indoor_nodes", "ui_locations_details_indoor_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16822, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16074, 57),
      ))
    }

@delegate:ResourceContentHash(-782_867_406)
internal val Res.string.ui_locations_details_offline_devices: StringResource by lazy {
      StringResource("string:ui_locations_details_offline_devices", "ui_locations_details_offline_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16888, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16132, 64),
      ))
    }

@delegate:ResourceContentHash(1_221_464_412)
internal val Res.string.ui_locations_details_online_devices: StringResource by lazy {
      StringResource("string:ui_locations_details_online_devices", "ui_locations_details_online_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 16961, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16197, 63),
      ))
    }

@delegate:ResourceContentHash(1_624_471_103)
internal val Res.string.ui_locations_details_outdoor_nodes: StringResource by lazy {
      StringResource("string:ui_locations_details_outdoor_nodes", "ui_locations_details_outdoor_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17029, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16261, 62),
      ))
    }

@delegate:ResourceContentHash(1_816_220_427)
internal val Res.string.ui_locations_edit_btn_add_range: StringResource by lazy {
      StringResource("string:ui_locations_edit_btn_add_range", "ui_locations_edit_btn_add_range", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17096, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16324, 55),
      ))
    }

@delegate:ResourceContentHash(936_220_866)
internal val Res.string.ui_locations_edit_btn_save: StringResource by lazy {
      StringResource("string:ui_locations_edit_btn_save", "ui_locations_edit_btn_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17156, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16380, 42),
      ))
    }

@delegate:ResourceContentHash(-675_808_415)
internal val Res.string.ui_locations_edit_halted: StringResource by lazy {
      StringResource("string:ui_locations_edit_halted", "ui_locations_edit_halted", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17199, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16423, 56),
      ))
    }

@delegate:ResourceContentHash(267_520_369)
internal val Res.string.ui_locations_edit_label_address: StringResource by lazy {
      StringResource("string:ui_locations_edit_label_address", "ui_locations_edit_label_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17264, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16480, 63),
      ))
    }

@delegate:ResourceContentHash(-1_568_105_249)
internal val Res.string.ui_locations_edit_label_name: StringResource by lazy {
      StringResource("string:ui_locations_edit_label_name", "ui_locations_edit_label_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17324, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16544, 56),
      ))
    }

@delegate:ResourceContentHash(-902_466_203)
internal val Res.string.ui_locations_edit_label_opening_hours: StringResource by lazy {
      StringResource("string:ui_locations_edit_label_opening_hours", "ui_locations_edit_label_opening_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17381, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16601, 65),
      ))
    }

@delegate:ResourceContentHash(1_911_406_153)
internal val Res.string.ui_locations_edit_placeholder_address: StringResource by lazy {
      StringResource("string:ui_locations_edit_placeholder_address", "ui_locations_edit_placeholder_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17447, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16667, 69),
      ))
    }

@delegate:ResourceContentHash(80_470_140)
internal val Res.string.ui_locations_edit_range_to: StringResource by lazy {
      StringResource("string:ui_locations_edit_range_to", "ui_locations_edit_range_to", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17517, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16737, 38),
      ))
    }

@delegate:ResourceContentHash(-1_733_012_182)
internal val Res.string.ui_locations_edit_remove_range: StringResource by lazy {
      StringResource("string:ui_locations_edit_remove_range", "ui_locations_edit_remove_range", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17556, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16776, 54),
      ))
    }

@delegate:ResourceContentHash(-1_222_290_261)
internal val Res.string.ui_locations_edit_time: StringResource by lazy {
      StringResource("string:ui_locations_edit_time", "ui_locations_edit_time", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17615, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16831, 38),
      ))
    }

@delegate:ResourceContentHash(-1_385_667_318)
internal val Res.string.ui_locations_listing_btn_new: StringResource by lazy {
      StringResource("string:ui_locations_listing_btn_new", "ui_locations_listing_btn_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17658, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16870, 48),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_locations_listing_header_devices: StringResource by lazy {
      StringResource("string:ui_locations_listing_header_devices", "ui_locations_listing_header_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17707, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16919, 55),
      ))
    }

@delegate:ResourceContentHash(81_821_120)
internal val Res.string.ui_locations_listing_header_id: StringResource by lazy {
      StringResource("string:ui_locations_listing_header_id", "ui_locations_listing_header_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17763, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16975, 42),
      ))
    }

@delegate:ResourceContentHash(-339_871_113)
internal val Res.string.ui_locations_listing_header_name_address: StringResource by lazy {
      StringResource("string:ui_locations_listing_header_name_address", "ui_locations_listing_header_name_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17806, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17018, 80),
      ))
    }

@delegate:ResourceContentHash(-1_131_027_589)
internal val Res.string.ui_locations_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_locations_listing_search_placeholder", "ui_locations_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17887, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17099, 63),
      ))
    }

@delegate:ResourceContentHash(-843_623_927)
internal val Res.string.ui_locations_listing_showing: StringResource by lazy {
      StringResource("string:ui_locations_listing_showing", "ui_locations_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 17987, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17163, 84),
      ))
    }

@delegate:ResourceContentHash(-1_590_321_951)
internal val Res.string.ui_locations_splash_desc: StringResource by lazy {
      StringResource("string:ui_locations_splash_desc", "ui_locations_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18076, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17248, 188),
      ))
    }

@delegate:ResourceContentHash(-1_977_843_466)
internal val Res.string.ui_locations_splash_title: StringResource by lazy {
      StringResource("string:ui_locations_splash_title", "ui_locations_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18293, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17437, 45),
      ))
    }

@delegate:ResourceContentHash(-1_429_762_933)
internal val Res.string.ui_login_access: StringResource by lazy {
      StringResource("string:ui_login_access", "ui_login_access", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18339, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17483, 43),
      ))
    }

@delegate:ResourceContentHash(-1_515_607_493)
internal val Res.string.ui_login_btn_authorize: StringResource by lazy {
      StringResource("string:ui_login_btn_authorize", "ui_login_btn_authorize", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18383, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17527, 42),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_login_change_password_btn_cancel: StringResource by lazy {
      StringResource("string:ui_login_change_password_btn_cancel", "ui_login_change_password_btn_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18430, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17570, 51),
      ))
    }

@delegate:ResourceContentHash(-1_918_958_121)
internal val Res.string.ui_login_change_password_btn_confirm: StringResource by lazy {
      StringResource("string:ui_login_change_password_btn_confirm", "ui_login_change_password_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18486, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17622, 56),
      ))
    }

@delegate:ResourceContentHash(-1_966_453_734)
internal val Res.string.ui_login_change_password_desc: StringResource by lazy {
      StringResource("string:ui_login_change_password_desc", "ui_login_change_password_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18543, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17679, 125),
      ))
    }

@delegate:ResourceContentHash(-1_507_393_802)
internal val Res.string.ui_login_change_password_error: StringResource by lazy {
      StringResource("string:ui_login_change_password_error", "ui_login_change_password_error", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18677, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17805, 74),
      ))
    }

@delegate:ResourceContentHash(1_010_528_118)
internal val Res.string.ui_login_change_password_label_new: StringResource by lazy {
      StringResource("string:ui_login_change_password_label_new", "ui_login_change_password_label_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18756, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17880, 58),
      ))
    }

@delegate:ResourceContentHash(-529_968_707)
internal val Res.string.ui_login_change_password_label_repeat: StringResource by lazy {
      StringResource("string:ui_login_change_password_label_repeat", "ui_login_change_password_label_repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18815, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17939, 65),
      ))
    }

@delegate:ResourceContentHash(-178_330_454)
internal val Res.string.ui_login_change_password_placeholder_new: StringResource by lazy {
      StringResource("string:ui_login_change_password_placeholder_new", "ui_login_change_password_placeholder_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18885, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18005, 72),
      ))
    }

@delegate:ResourceContentHash(-1_082_015_208)
internal val Res.string.ui_login_change_password_placeholder_repeat: StringResource by lazy {
      StringResource("string:ui_login_change_password_placeholder_repeat", "ui_login_change_password_placeholder_repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 18962, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18078, 79),
      ))
    }

@delegate:ResourceContentHash(-53_236_595)
internal val Res.string.ui_login_change_password_title: StringResource by lazy {
      StringResource("string:ui_login_change_password_title", "ui_login_change_password_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19042, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18158, 58),
      ))
    }

@delegate:ResourceContentHash(508_698_892)
internal val Res.string.ui_login_invalid: StringResource by lazy {
      StringResource("string:ui_login_invalid", "ui_login_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19105, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18217, 52),
      ))
    }

@delegate:ResourceContentHash(-2_051_282_826)
internal val Res.string.ui_login_password: StringResource by lazy {
      StringResource("string:ui_login_password", "ui_login_password", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19162, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18270, 37),
      ))
    }

@delegate:ResourceContentHash(1_041_238_001)
internal val Res.string.ui_login_username: StringResource by lazy {
      StringResource("string:ui_login_username", "ui_login_username", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19200, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18308, 33),
      ))
    }

@delegate:ResourceContentHash(80_528_753)
internal val Res.string.ui_logout_dialog_btn_confirm: StringResource by lazy {
      StringResource("string:ui_logout_dialog_btn_confirm", "ui_logout_dialog_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19238, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18342, 40),
      ))
    }

@delegate:ResourceContentHash(83_454_045)
internal val Res.string.ui_logout_dialog_btn_dismiss: StringResource by lazy {
      StringResource("string:ui_logout_dialog_btn_dismiss", "ui_logout_dialog_btn_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19279, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18383, 40),
      ))
    }

@delegate:ResourceContentHash(-2_062_536_096)
internal val Res.string.ui_logout_dialog_message: StringResource by lazy {
      StringResource("string:ui_logout_dialog_message", "ui_logout_dialog_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19320, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18424, 76),
      ))
    }

@delegate:ResourceContentHash(-783_407_287)
internal val Res.string.ui_logout_dialog_title: StringResource by lazy {
      StringResource("string:ui_logout_dialog_title", "ui_logout_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19409, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18501, 38),
      ))
    }

@delegate:ResourceContentHash(262_444_405)
internal val Res.string.ui_resources_detail_aspect_ratio: StringResource by lazy {
      StringResource("string:ui_resources_detail_aspect_ratio", "ui_resources_detail_aspect_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19448, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18540, 56),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_resources_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_resources_detail_btn_delete", "ui_resources_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19509, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18597, 46),
      ))
    }

@delegate:ResourceContentHash(2_102_303_880)
internal val Res.string.ui_resources_detail_btn_download: StringResource by lazy {
      StringResource("string:ui_resources_detail_btn_download", "ui_resources_detail_btn_download", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19560, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18644, 52),
      ))
    }

@delegate:ResourceContentHash(-1_833_084_223)
internal val Res.string.ui_resources_detail_conversion: StringResource by lazy {
      StringResource("string:ui_resources_detail_conversion", "ui_resources_detail_conversion", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19613, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18697, 54),
      ))
    }

@delegate:ResourceContentHash(2_088_991_756)
internal val Res.string.ui_resources_detail_date_added: StringResource by lazy {
      StringResource("string:ui_resources_detail_date_added", "ui_resources_detail_date_added", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19668, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18752, 54),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_resources_detail_delete_btn_confirm: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_btn_confirm", "ui_resources_detail_delete_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19727, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18807, 54),
      ))
    }

@delegate:ResourceContentHash(1_573_769_046)
internal val Res.string.ui_resources_detail_delete_btn_dismiss: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_btn_dismiss", "ui_resources_detail_delete_btn_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19786, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18862, 58),
      ))
    }

@delegate:ResourceContentHash(-2_026_603_457)
internal val Res.string.ui_resources_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_confirm_message", "ui_resources_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19845, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18921, 122),
      ))
    }

@delegate:ResourceContentHash(105_616_997)
internal val Res.string.ui_resources_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_confirm_title", "ui_resources_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 19976, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19044, 64),
      ))
    }

@delegate:ResourceContentHash(944_689_656)
internal val Res.string.ui_resources_detail_description: StringResource by lazy {
      StringResource("string:ui_resources_detail_description", "ui_resources_detail_description", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20045, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19109, 55),
      ))
    }

@delegate:ResourceContentHash(-454_368_180)
internal val Res.string.ui_resources_detail_dominant_palette: StringResource by lazy {
      StringResource("string:ui_resources_detail_dominant_palette", "ui_resources_detail_dominant_palette", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20093, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19165, 68),
      ))
    }

@delegate:ResourceContentHash(1_132_501_738)
internal val Res.string.ui_resources_detail_duration: StringResource by lazy {
      StringResource("string:ui_resources_detail_duration", "ui_resources_detail_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20162, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19234, 48),
      ))
    }

@delegate:ResourceContentHash(879_476_198)
internal val Res.string.ui_resources_detail_file_name: StringResource by lazy {
      StringResource("string:ui_resources_detail_file_name", "ui_resources_detail_file_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20211, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19283, 49),
      ))
    }

@delegate:ResourceContentHash(-1_551_940_619)
internal val Res.string.ui_resources_detail_file_size: StringResource by lazy {
      StringResource("string:ui_resources_detail_file_size", "ui_resources_detail_file_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20269, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19333, 49),
      ))
    }

@delegate:ResourceContentHash(1_661_036_776)
internal val Res.string.ui_resources_detail_file_type: StringResource by lazy {
      StringResource("string:ui_resources_detail_file_type", "ui_resources_detail_file_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20331, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19383, 49),
      ))
    }

@delegate:ResourceContentHash(-1_634_630_944)
internal val Res.string.ui_resources_detail_info: StringResource by lazy {
      StringResource("string:ui_resources_detail_info", "ui_resources_detail_info", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20389, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19433, 40),
      ))
    }

@delegate:ResourceContentHash(-579_069_472)
internal val Res.string.ui_resources_detail_metadata_tags: StringResource by lazy {
      StringResource("string:ui_resources_detail_metadata_tags", "ui_resources_detail_metadata_tags", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20430, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19474, 61),
      ))
    }

@delegate:ResourceContentHash(-609_707_740)
internal val Res.string.ui_resources_detail_no_description: StringResource by lazy {
      StringResource("string:ui_resources_detail_no_description", "ui_resources_detail_no_description", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20496, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19536, 74),
      ))
    }

@delegate:ResourceContentHash(-181_754_221)
internal val Res.string.ui_resources_detail_orientation: StringResource by lazy {
      StringResource("string:ui_resources_detail_orientation", "ui_resources_detail_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20563, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19611, 55),
      ))
    }

@delegate:ResourceContentHash(-576_114_565)
internal val Res.string.ui_resources_detail_resolution: StringResource by lazy {
      StringResource("string:ui_resources_detail_resolution", "ui_resources_detail_resolution", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20619, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19667, 54),
      ))
    }

@delegate:ResourceContentHash(-1_298_430_027)
internal val Res.string.ui_resources_detail_status_fail: StringResource by lazy {
      StringResource("string:ui_resources_detail_status_fail", "ui_resources_detail_status_fail", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20674, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19722, 47),
      ))
    }

@delegate:ResourceContentHash(2_129_101_214)
internal val Res.string.ui_resources_detail_status_processing: StringResource by lazy {
      StringResource("string:ui_resources_detail_status_processing", "ui_resources_detail_status_processing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20726, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19770, 61),
      ))
    }

@delegate:ResourceContentHash(422_955_991)
internal val Res.string.ui_resources_detail_status_ready: StringResource by lazy {
      StringResource("string:ui_resources_detail_status_ready", "ui_resources_detail_status_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20780, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19832, 48),
      ))
    }

@delegate:ResourceContentHash(-394_292_674)
internal val Res.string.ui_resources_detail_technical_specs: StringResource by lazy {
      StringResource("string:ui_resources_detail_technical_specs", "ui_resources_detail_technical_specs", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20833, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19881, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_devices_edit_deviceeui_mode_picker", Res.string.ui_devices_edit_deviceeui_mode_picker)
  map.put("ui_devices_edit_deviceeui_no_image", Res.string.ui_devices_edit_deviceeui_no_image)
  map.put("ui_devices_edit_deviceeui_no_locations_found", Res.string.ui_devices_edit_deviceeui_no_locations_found)
  map.put("ui_devices_edit_deviceeui_ok", Res.string.ui_devices_edit_deviceeui_ok)
  map.put("ui_devices_edit_deviceeui_orientation_horizontal", Res.string.ui_devices_edit_deviceeui_orientation_horizontal)
  map.put("ui_devices_edit_deviceeui_orientation_horizontal_reversed", Res.string.ui_devices_edit_deviceeui_orientation_horizontal_reversed)
  map.put("ui_devices_edit_deviceeui_orientation_vertical", Res.string.ui_devices_edit_deviceeui_orientation_vertical)
  map.put("ui_devices_edit_deviceeui_orientation_vertical_reversed", Res.string.ui_devices_edit_deviceeui_orientation_vertical_reversed)
  map.put("ui_devices_edit_deviceeui_search_location_placeholder", Res.string.ui_devices_edit_deviceeui_search_location_placeholder)
  map.put("ui_devices_edit_deviceeui_select_location_placeholder", Res.string.ui_devices_edit_deviceeui_select_location_placeholder)
  map.put("ui_devices_listing_btn_load_more", Res.string.ui_devices_listing_btn_load_more)
  map.put("ui_devices_listing_header_campaigns", Res.string.ui_devices_listing_header_campaigns)
  map.put("ui_devices_listing_header_id", Res.string.ui_devices_listing_header_id)
  map.put("ui_devices_listing_header_name", Res.string.ui_devices_listing_header_name)
  map.put("ui_devices_listing_header_status", Res.string.ui_devices_listing_header_status)
  map.put("ui_devices_listing_header_type", Res.string.ui_devices_listing_header_type)
  map.put("ui_devices_listing_placeholder_search", Res.string.ui_devices_listing_placeholder_search)
  map.put("ui_devices_listing_showing", Res.string.ui_devices_listing_showing)
  map.put("ui_devices_listing_showing_middle", Res.string.ui_devices_listing_showing_middle)
  map.put("ui_devices_listing_showing_prefix", Res.string.ui_devices_listing_showing_prefix)
  map.put("ui_devices_listing_showing_suffix", Res.string.ui_devices_listing_showing_suffix)
  map.put("ui_devices_listing_stat_offline", Res.string.ui_devices_listing_stat_offline)
  map.put("ui_devices_listing_stat_online", Res.string.ui_devices_listing_stat_online)
  map.put("ui_devices_listing_stat_total", Res.string.ui_devices_listing_stat_total)
  map.put("ui_devices_listing_title", Res.string.ui_devices_listing_title)
  map.put("ui_devices_listing_type_indoor", Res.string.ui_devices_listing_type_indoor)
  map.put("ui_devices_listing_type_outdoor", Res.string.ui_devices_listing_type_outdoor)
  map.put("ui_devices_splash_desc", Res.string.ui_devices_splash_desc)
  map.put("ui_devices_splash_title", Res.string.ui_devices_splash_title)
  map.put("ui_locations_detail_btn_delete", Res.string.ui_locations_detail_btn_delete)
  map.put("ui_locations_detail_btn_edit", Res.string.ui_locations_detail_btn_edit)
  map.put("ui_locations_detail_delete_confirm_message", Res.string.ui_locations_detail_delete_confirm_message)
  map.put("ui_locations_detail_delete_confirm_title", Res.string.ui_locations_detail_delete_confirm_title)
  map.put("ui_locations_detail_delete_failed", Res.string.ui_locations_detail_delete_failed)
  map.put("ui_locations_detail_devices_count", Res.string.ui_locations_detail_devices_count)
  map.put("ui_locations_detail_search_hint", Res.string.ui_locations_detail_search_hint)
  map.put("ui_locations_details_indoor_nodes", Res.string.ui_locations_details_indoor_nodes)
  map.put("ui_locations_details_offline_devices", Res.string.ui_locations_details_offline_devices)
  map.put("ui_locations_details_online_devices", Res.string.ui_locations_details_online_devices)
  map.put("ui_locations_details_outdoor_nodes", Res.string.ui_locations_details_outdoor_nodes)
  map.put("ui_locations_edit_btn_add_range", Res.string.ui_locations_edit_btn_add_range)
  map.put("ui_locations_edit_btn_save", Res.string.ui_locations_edit_btn_save)
  map.put("ui_locations_edit_halted", Res.string.ui_locations_edit_halted)
  map.put("ui_locations_edit_label_address", Res.string.ui_locations_edit_label_address)
  map.put("ui_locations_edit_label_name", Res.string.ui_locations_edit_label_name)
  map.put("ui_locations_edit_label_opening_hours", Res.string.ui_locations_edit_label_opening_hours)
  map.put("ui_locations_edit_placeholder_address", Res.string.ui_locations_edit_placeholder_address)
  map.put("ui_locations_edit_range_to", Res.string.ui_locations_edit_range_to)
  map.put("ui_locations_edit_remove_range", Res.string.ui_locations_edit_remove_range)
  map.put("ui_locations_edit_time", Res.string.ui_locations_edit_time)
  map.put("ui_locations_listing_btn_new", Res.string.ui_locations_listing_btn_new)
  map.put("ui_locations_listing_header_devices", Res.string.ui_locations_listing_header_devices)
  map.put("ui_locations_listing_header_id", Res.string.ui_locations_listing_header_id)
  map.put("ui_locations_listing_header_name_address", Res.string.ui_locations_listing_header_name_address)
  map.put("ui_locations_listing_search_placeholder", Res.string.ui_locations_listing_search_placeholder)
  map.put("ui_locations_listing_showing", Res.string.ui_locations_listing_showing)
  map.put("ui_locations_splash_desc", Res.string.ui_locations_splash_desc)
  map.put("ui_locations_splash_title", Res.string.ui_locations_splash_title)
  map.put("ui_login_access", Res.string.ui_login_access)
  map.put("ui_login_btn_authorize", Res.string.ui_login_btn_authorize)
  map.put("ui_login_change_password_btn_cancel", Res.string.ui_login_change_password_btn_cancel)
  map.put("ui_login_change_password_btn_confirm", Res.string.ui_login_change_password_btn_confirm)
  map.put("ui_login_change_password_desc", Res.string.ui_login_change_password_desc)
  map.put("ui_login_change_password_error", Res.string.ui_login_change_password_error)
  map.put("ui_login_change_password_label_new", Res.string.ui_login_change_password_label_new)
  map.put("ui_login_change_password_label_repeat", Res.string.ui_login_change_password_label_repeat)
  map.put("ui_login_change_password_placeholder_new", Res.string.ui_login_change_password_placeholder_new)
  map.put("ui_login_change_password_placeholder_repeat", Res.string.ui_login_change_password_placeholder_repeat)
  map.put("ui_login_change_password_title", Res.string.ui_login_change_password_title)
  map.put("ui_login_invalid", Res.string.ui_login_invalid)
  map.put("ui_login_password", Res.string.ui_login_password)
  map.put("ui_login_username", Res.string.ui_login_username)
  map.put("ui_logout_dialog_btn_confirm", Res.string.ui_logout_dialog_btn_confirm)
  map.put("ui_logout_dialog_btn_dismiss", Res.string.ui_logout_dialog_btn_dismiss)
  map.put("ui_logout_dialog_message", Res.string.ui_logout_dialog_message)
  map.put("ui_logout_dialog_title", Res.string.ui_logout_dialog_title)
  map.put("ui_resources_detail_aspect_ratio", Res.string.ui_resources_detail_aspect_ratio)
  map.put("ui_resources_detail_btn_delete", Res.string.ui_resources_detail_btn_delete)
  map.put("ui_resources_detail_btn_download", Res.string.ui_resources_detail_btn_download)
  map.put("ui_resources_detail_conversion", Res.string.ui_resources_detail_conversion)
  map.put("ui_resources_detail_date_added", Res.string.ui_resources_detail_date_added)
  map.put("ui_resources_detail_delete_btn_confirm", Res.string.ui_resources_detail_delete_btn_confirm)
  map.put("ui_resources_detail_delete_btn_dismiss", Res.string.ui_resources_detail_delete_btn_dismiss)
  map.put("ui_resources_detail_delete_confirm_message", Res.string.ui_resources_detail_delete_confirm_message)
  map.put("ui_resources_detail_delete_confirm_title", Res.string.ui_resources_detail_delete_confirm_title)
  map.put("ui_resources_detail_description", Res.string.ui_resources_detail_description)
  map.put("ui_resources_detail_dominant_palette", Res.string.ui_resources_detail_dominant_palette)
  map.put("ui_resources_detail_duration", Res.string.ui_resources_detail_duration)
  map.put("ui_resources_detail_file_name", Res.string.ui_resources_detail_file_name)
  map.put("ui_resources_detail_file_size", Res.string.ui_resources_detail_file_size)
  map.put("ui_resources_detail_file_type", Res.string.ui_resources_detail_file_type)
  map.put("ui_resources_detail_info", Res.string.ui_resources_detail_info)
  map.put("ui_resources_detail_metadata_tags", Res.string.ui_resources_detail_metadata_tags)
  map.put("ui_resources_detail_no_description", Res.string.ui_resources_detail_no_description)
  map.put("ui_resources_detail_orientation", Res.string.ui_resources_detail_orientation)
  map.put("ui_resources_detail_resolution", Res.string.ui_resources_detail_resolution)
  map.put("ui_resources_detail_status_fail", Res.string.ui_resources_detail_status_fail)
  map.put("ui_resources_detail_status_processing", Res.string.ui_resources_detail_status_processing)
  map.put("ui_resources_detail_status_ready", Res.string.ui_resources_detail_status_ready)
  map.put("ui_resources_detail_technical_specs", Res.string.ui_resources_detail_technical_specs)
}
